<template>
  <div class="content">
    <el-form ref="schemeForm" :model="schemeForm" label-width="100px">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>方案信息</span>
        </div>
        <el-form-item label="方案名称" prop="name" style="width:60%">
            <el-input v-model="schemeForm.name" placeholder="方案名称"></el-input>
        </el-form-item>
        <el-form-item label="代理商" prop="userId" style="width:60%">
            <span>[{{schemeForm.username}}]{{schemeForm.companyName}}</span>
        </el-form-item>
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>套餐信息</span>
        </div>
        <el-form-item label="" style="margin-top: 10px;">
          <el-table :data="schemeForm.services" row-key="id"
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
            <el-table-column type="index" align="center" width="60px"></el-table-column>
            <el-table-column prop="productName" label="套餐名称" align="center"  :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="operationName" label="运营商" align="center"  ></el-table-column>
            <el-table-column v-if="adminShow" prop="ledgerPrice" label="底价（元）" align="center"  ></el-table-column>
            <el-table-column v-if="!adminShow" prop="ledgerPrice" label="成本价（元）" align="center"  ></el-table-column>
          </el-table>
        </el-form-item>
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix box-title">
            <span>卡片信息</span>
        </div>
        <el-table :data="tableData" v-loading="loading">
            <el-table-column type="index" label="编号" align="center" width="100"></el-table-column>
            <el-table-column prop="iccid" label="ICCID" align="center"></el-table-column>
            <el-table-column prop="msisdn" label="MSISDN" align="center"></el-table-column>
            <el-table-column prop="status" label="状态" align="center">
              <template slot-scope="{row}">
                 <el-tag v-if="row.status == '1'" >已分配</el-tag>
                 <el-tag v-if="row.status == '0'" type="warning">未分配</el-tag>
              </template>
            </el-table-column>
        </el-table>
        <div class="block" style="margin-top: 30px;">
            <pagination v-show="total>0" :total="total" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" :page.sync="page"
            :limit.sync="pageSize" @pagination="initData" />
        </div>
      </el-card>
      
    </el-form>
  </div>
</template>
<script>
import { baseSchemeProductSubList , baseSchemeCard , schemeDetail} from "@/api/api.js"; 
export default {
  name:'editScheme',
  data() {
    return {
      schemeId:undefined,
      schemeForm:{
        username:undefined,
        companyName:undefined,
        services:[]
      },
      loading:false,
      tableData:[],
      total:0,
      page:1,
      pageSize:10,
    };
  },
  computed: {
    adminShow(){
      return this.$store.getters.user.userType =='1'
    }
  },
  methods: {
    initData(){
      this.loading = true;
      let params = {
        model:{
		      schemeId:this.schemeId,
		    },
        page: this.page,
        pageSize: this.pageSize,
      };
      baseSchemeCard(params).then(res => {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
          this.loading = false;
      });
    },
    initSchemeDetail(){
      schemeDetail({schemeId:this.schemeId}).then(res=>{
          this.schemeForm = res.data.data
      })

    },
    initSubSchemeProduct(){
        baseSchemeProductSubList({id:this.schemeId}).then(res=>{
            this.schemeForm.services = res.data.data
        })
    },
  },
  mounted() {
  },
  created() {
    this.schemeId = this.$route.params && this.$route.params.id
    this.initData()
    this.initSchemeDetail()
  }
};
</script>
<style scoped lang="less">
  .box-card {
    margin-bottom: 26px;
  }
  .foot {
		width: calc(100% - 200px);
		position: fixed;
		right: 0;
		bottom: 0;
		height: 60px;
		line-height: 60px;
		background-color: white;
		text-align: center;
		padding: 0 20px
	}
</style>
